import styled from "styled-components";

export const AdminPageBox = styled.div`
    height: 100vh;
    padding-top: 60px;
    display: flex;
`;

export const LayoutBox = styled.div`
    width: calc(100% - 150px);
`;

export const ChildTitle = styled.h3`
    text-align: center;
    padding: 10px 0;
    border-bottom: 1px solid #afafaf;
`;